import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var $: any;
declare var bootstrap: any;

@Injectable()
export class Helpers {

  setDataTableSearchDelay() {
    var searchDelay = null;

    setTimeout(function () {
      $('.dataTables_filter input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function (e) {
          var search = $('div.dataTables_filter input').val();
          clearTimeout(searchDelay);

          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }

  getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => {
      if (object[key] != null) {
        if (object[key].constructor.name == "Array" && (object[key].length > 0 && object[key][0].constructor.name != "File")) {
          let i = 0;
          object[key].forEach(function (arr) {
            formData.append(`${key}[${i}]`, arr);
            i++;
          })
        } else if (object[key].constructor.name == "Array" && (object[key].length > 0 && object[key][0].constructor.name == "File")) {
          object[key].forEach(function (arr) {
            formData.append(key, arr);
          });
        }
        else if (object[key].constructor.name != "Array") {
          formData.append(key, object[key]);
        }
      }
    });
    return formData;
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  /**
   * Devuelve una fecha del tipo DateTime en 2 partes y con iconos de fecha y hora
   * @param {string} stringDate : Fecha hora en formato texto
   * @return {string} newStringDate
   */
  formatDateTimeWithIcons(stringDate: string) {
    stringDate = stringDate.replace(/<[^>]*>/g, '').trim();
    let newStringDate = '';
    let tempStringArr = stringDate.split(' ');
    let tempString = '<i class="fa fa-calendar"></i> ';
    tempString += tempStringArr[0];
    if (tempStringArr.length > 1) {
      tempString += '<i class="fa fa-clock-o ms-2"></i> ';
      tempString += tempStringArr[1];
    }
    newStringDate = tempString;
    return newStringDate;
  }

  /**
   * Activa los tooltips de Bootstrap
   * Usado tras un cambio en el DOM
   * Sobre todo en los datatables
   */
  enableBsTooltips() {
    var tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipElements.forEach(function (tooltipElement) {
      var tooltip = bootstrap.Tooltip.getOrCreateInstance(tooltipElement);
      // tooltipElement.addEventListener('click', function () {
      //   var tooltipToDelete = document.querySelector('.tooltip');
      //   if (tooltipToDelete) {
      //     tooltipToDelete.remove();
      //   }
      // })
    });
    $('[data-bs-toggle="tooltip"]').on("mousedown", function () {
      $('.tooltip').remove();

    });
  }

  /**
    * Activa los popovers de Bootstrap
    * Usado tras un cambio en el DOM
    * Sobre todo en los datatables
    */
  enableBsPopovers() {
    var popoverElements = document.querySelectorAll('[data-bs-toggle="popover"]');
    popoverElements.forEach(function (popoverElement) {
      var popover = bootstrap.Popover.getOrCreateInstance(popoverElement);
    });
    $('[data-bs-toggle="popover"]').on("mousedown", function () {
      $('.popover').remove();
    });
  }

  isApiUrl(req: any) {
    if (req.url.startsWith(environment.urlAPI)) {
      return true;
    }
    return false;
  }

  isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }

  /**
   * Comprueba si estamos en un entorno de desarrollo
   * Usa como referencia la URL de la API
   */
  isInDevEnvironment() {
    // It's a development remote url.
    if (environment.urlAPI.startsWith('https://dev-api')) {
      return true;
    }

    // It's a development local url.
    if (environment.urlAPI.startsWith('https://localhost')) {
      return true;
    }

    return false;
  }

  animateDataTable(table: HTMLElement) {
    var tableWrapper = table.closest('div.fadein-table');
    tableWrapper.classList.add('show');
  }
}


